import React, { Component, PropTypes } from 'react'
import CSSModules from 'react-css-modules'
import config from '../../config'
import {
  Link,
  LinkIcon
} from '../'
import Styles from './ManagerSjfSurvey.css'

/*
 * Button link to the survey
 */
class ManagerSjfSurveyLink extends Component {
  render() {
    return <Link
      to={config.links.fundManagerSurvey}
      roundbutton
    >
      Manager survey<LinkIcon />
    </Link>
  }
}


/*
 * Section panel for manager statement content
 * TODO
 * build google form
 *    finalize questions for survey
 *      confirm who needs to review
 *      standard doc to hold questions
 *    draft form instructions for submitters
 *      make it clear: NO LINKS allowed
 *    what google account to use?
 *    confirm how we're alerted when someone fills out form
 * pipeline to extract answers from google form and store as JSON
 *    indexed by fund family name
 *    some level of manual mapping needed here
 *    store manager statements in data/ JSON file
 * Check if manager has submitted statement
 *    check for presence of manager name in JSON file
 *    if not found, generic <FundManagerSjfNoStatement />
 *    if found, render answers
 *      question: answer
 *
 */
@CSSModules(Styles, {allowMultiple:true})
export default class ManagerSjfSurvey extends Component {
  static propTypes = {
    fundFamilyName: PropTypes.string.isRequired,
  }
  //
  constructor(props){
    super(props)

    let surveyAnswers = null
    if (config.managerSjfSurveyAnswers.hasOwnProperty(props.fundFamilyName)) {
      surveyAnswers = config.managerSjfSurveyAnswers[props.fundFamilyName]
    }

    this.state = {
      surveyQuestions: [
        'What is your investment vehicle\'s thesis for how it contributes to social justice?',
        'How does your investment vehicle engage held companies to encourage improved social justice practices?',
        'How does your investment vehicle ensure sufficiency of data related to social justice?',
        'How does your investment vehicle utilize social justice-related data?',
        'What are the discernible positive social justice outcomes associated with your investment vehicle?',
        'Is there additional relevant content you would like to share?',
      ],
      surveyAnswers
    }
  }
  //
  render() {
    return <section
      styleName='manager-survey'
      aria-labelledby='manager-survey-title'
    >
      <h2
        id='manager-survey-title'
        styleName='manager-survey__headline'
      >
        Fund manager statement
      </h2>

      <p styleName='manager-survey__tagline'>
        We invite fund managers to take our survey and provide more
        information on how they integrate principles of justice and equity
        in their investment strategy.
      </p>

      {
        this.state.surveyAnswers && this.state.surveyAnswers.length > 0 ?
          <div>

            <p styleName='manager-survey__tagline'>
              {this.props.fundFamilyName} provided these answers to our
              survey:
            </p>

            {
              this.state.surveyQuestions.map((e, i) => {
                return <div
                  key={'manager-survey__answer-list-'+i}
                  styleName='manager-survey__answer-list'
                >

                  <div styleName='manager-survey__question'>
                    { e }
                  </div>
                  <div styleName='manager-survey__answer'>
                    { this.state.surveyAnswers[i] }
                  </div>

                </div>
              })
            }

            <p styleName='manager-survey__tagline'>
              To update these answers, fund managers can submit new
              information to our survey.
            </p>

          </div> :
          null
      }

      <ManagerSjfSurveyLink />

    </section>
  }
}

